// История этапов воронки. Сценарий 85 требует, чтобы она сохранялась и была видна: без неё
// на вопрос «почему он в листе ожидания» ответа нет ни у кого, включая того, кто его туда
// поставил.
//
// Читается сверху вниз, от свежего к старому: человек открывает вкладку, чтобы узнать, что
// случилось ПОСЛЕДНИМ, а не с чего всё началось.
//
// Причина показывается всегда, и её отсутствие — отдельный факт, а не пустая строка: «этап
// сменили молча» это ровно то, из-за чего через полгода никто ничего не помнит.

import { RiHistoryLine } from '@remixicon/react';

import { parseMoment } from '@/shared/time/format';
import { ScreenState, Skeleton } from '@/shared/ui/screen-state';
import { EmptyState } from '@/shared/ui/screen-state';

import type { CandidateOut } from '../api/candidates';
import { CANDIDATE_STATUS_TITLES, candidateStatusTitle } from '../dictionaries';
import { useStatusHistoryQuery } from '../queries';

export function HistoryTab({ candidate }: { candidate: CandidateOut }) {
  // История приезжает и внутри карточки, и отдельным маршрутом. Берём отдельный: после смены
  // этапа он обновляется своим ключом, и вкладка показывает свежую запись сразу, а не после
  // перезагрузки всей карточки.
  const query = useStatusHistoryQuery(candidate.id);

  return (
    <div className='flex flex-col gap-3 p-5'>
      <ScreenState
        data={query.data}
        error={query.error}
        subject='историю этапов'
        isEmpty={(data) => data.items.length === 0}
        onRetry={() => void query.refetch()}
        loading={
          <div className='flex flex-col gap-2'>
            <Skeleton className='h-12 w-full' />
            <Skeleton className='h-12 w-full' />
          </div>
        }
        empty={
          <EmptyState
            icon={RiHistoryLine}
            title='Этап ещё ни разу не менялся'
            description={`Кандидат стоит там, где появился: «${CANDIDATE_STATUS_TITLES[candidate.status]}». Первая запись появится здесь, как только его сдвинут по воронке.`}
          />
        }
      >
        {(data) => (
          <ol className='flex flex-col'>
            {data.items.map((запись) => (
              <li
                key={запись.id}
                className='flex flex-col gap-0.5 border-b border-stroke-soft-200 py-3 last:border-b-0'
              >
                <span className='text-label-sm text-text-strong-950'>
                  {запись.status_from === null
                    ? `Заведён: ${candidateStatusTitle(запись.status_to)}`
                    : `${candidateStatusTitle(запись.status_from)} → ${candidateStatusTitle(запись.status_to)}`}
                </span>
                <span className='text-paragraph-xs text-text-sub-600'>
                  {parseMoment(запись.created_at)?.toLocaleString('ru-RU') ?? 'дата не пришла'}
                </span>
                <span className='text-paragraph-sm text-text-sub-600'>
                  {запись.reason === null || запись.reason === ''
                    ? 'Причина не записана — этап сменили без пояснения.'
                    : запись.reason}
                </span>
              </li>
            ))}
          </ol>
        )}
      </ScreenState>
    </div>
  );
}
